module.exports = __webpack_public_path__ + "img/basket2-fill.8c45c9ad.svg";